import { createDuration } from './create';

export function clone() {
    return createDuration(this);
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/duration/clone.js
// module id = 1350
// module chunks = 3